/*
 `BASE_URL_DEVELOPMENT` is replaced with `https://development.hse.de` when running locally.
 It is replaced with `` when NOT running locally
 This allows us to locally target development whereas in a deployed version URLs are kept relative
 */
export const enum EPathSegment {
  HOME = 'BASE_URL_DEVELOPMENT/',
  ACCOUNT = 'BASE_URL_DEVELOPMENT/dpl/av',
  CHECKOUT = 'BASE_URL_DEVELOPMENT/dpl/cv',
  BASKET = 'BASE_URL_DEVELOPMENT/dpl/bs/basket',
  SEARCH = 'BASE_URL_DEVELOPMENT/dpl/p/search',
  PRODUCT = 'BASE_URL_DEVELOPMENT/dpl/p/product',
  CATEGORY = 'BASE_URL_DEVELOPMENT/dpl/p/categories',
  COUNTRY_CODE = 'BASE_URL_DEVELOPMENT/dpl/ui/country-code',
  LOGIN_STATE = 'BASE_URL_DEVELOPMENT/dpl/cs/user/login-state',
  NEWSLETTER_SIGNUP = 'BASE_URL_DEVELOPMENT/dpl/nl/subscription',
  SUGGEST = 'BASE_URL_DEVELOPMENT/dpl/ffa/suggest/de',
}

export const BASE_PATH = '/dpl/ui'
